import { render, staticRenderFns } from "./SuppressionManager.vue?vue&type=template&id=6b16c232"
import script from "./SuppressionManager.vue?vue&type=script&lang=js"
export * from "./SuppressionManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports